export default "__VITE_ASSET__bdfa7519__"